__turbopack_context__.v({
  "checkbox-wrapper": "accordion-nav-button-module-scss-module__qEgibq__checkbox-wrapper",
  "selected": "accordion-nav-button-module-scss-module__qEgibq__selected",
  "sidebar-link": "accordion-nav-button-module-scss-module__qEgibq__sidebar-link",
  "with-delete-button": "accordion-nav-button-module-scss-module__qEgibq__with-delete-button",
});
